/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, $Sprite, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {Circle} from 'pixi.js';
import {$Button} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Button';
import {$Checkbox} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Checkbox';
import {$BetSelectPortrait} from './BetSelect';
import {uiMainScreenEmitter} from '../UIMainScreenEmitter';
import type {UIMainScreenUiProps} from './UIMainScreenUi';
import {uiElementsStore} from '@gongxigames/framework/slotV2/ui/services/UIElementsStates/uiElementsStore';
import {$TurboBtn} from './TurboBtn';
import {specialInfoZoneStore} from '@gongxigames/framework/slotV2/services/SpecialInfoZone/specialInfoZoneStore';
import {Store} from '@gongxigames/framework/core';
import {RContainer, ResponsiveConf, ResponsiveHandler} from '@gongxigames/framework/core/fragments/display/responsive';
import {cacheAsSprite} from '@gongxigames/framework/core/fragments/display/CacheAsSprite';
import {Rectangle} from 'pixi.js';

const GRAY_PANEL_HEIGHT = 138;

export const BUTTON_HIT_AREA = new Circle(0,0, 57);

export const $BottomPanelPortrait: FC<UIMainScreenUiProps> = (props) => {
    const panelHeight = specialInfoZoneStore.blackPanelHeight;
    const responsive = Store.computed(() => ({
        box: {y: '0', width: '100%'}, translate: {y: `${getProp(props.bottomPanelOffset)}px`}
    }) as ResponsiveConf);

    const gameRulesBetSelectPortrait = <$BetSelectPortrait
        responsive={{box: {x: '0', y: '0', width: '491px', height: '102px' }}}
        visible={true}
        betList={props.betList}
        betCurrent={props.betCurrent}
        betFormatted={props.betFormatted}
    /> as RContainer;

    new ResponsiveHandler(gameRulesBetSelectPortrait).update();

    cacheAsSprite.add({
        name: 'game_rules_bet_select_portrait',
        provider: gameRulesBetSelectPortrait,
        region: new Rectangle(-491/2, -102/2, 491, 102),
    });

    return <$Container name='bottom_panel_portrait'
        responsive={responsive}
    >
        <$Sprite
            name='background'
            texture='portrait_footer_sys_ui'
            responsive={{box: {y: '100%', width: '100%'}, translate: {y: '-479px'}, updateWidth: true}}
        />
        <$Container
            name='buttons'
            responsive={{
                box: {y: '100%', width: '100%', height: `${GRAY_PANEL_HEIGHT}px`},
                translate: {y: `${-(panelHeight.value + GRAY_PANEL_HEIGHT)}px`}
            }}
        >
            <$Checkbox
                name='sound_btn'
                value={props.soundEnabled}
                disabled={uiElementsStore.sound_btn_disabled}
                hitArea={BUTTON_HIT_AREA}
                action={() => uiMainScreenEmitter.emit('PRESSED_SOUND')}
                texturePrefix='sound_btn'
                responsive={{
                    box: {x: '50%', y: '50%'},
                    translate: {x: '-465px'}
                }}
            />
            <$Button
                name='menu_btn'
                disabled={uiElementsStore.menu_btn_disabled}
                hitArea={BUTTON_HIT_AREA}
                action={() => uiMainScreenEmitter.emit('PRESSED_MENU')}
                responsive={{
                    box: {x: '50%', y: '50%'},
                    translate: {x: '-328px'}
                }}
            />
            <$BetSelectPortrait
                responsive={{box: {x: '50%', y: '50%'}}}
                action={action => uiMainScreenEmitter.emit('PRESSED_BET_CHANGE', action)}
                betList={props.betList}
                betCurrent={props.betCurrent}
                betFormatted={props.betFormatted}
            />
            <$TurboBtn
                currentLevel={props.turboLevel}
                disabled={uiElementsStore.turbo_btn_disabled}
                hitArea={BUTTON_HIT_AREA}
                visible={props.showTurboModeButton}
                action={() => uiMainScreenEmitter.emit('PRESSED_TURBO')}
                responsive={{
                    box: {x: '50%', y: '50%'},
                    translate: {x: '328px'}
                }}
            />
            <$Button
                name='auto_btn'
                disabled={uiElementsStore.auto_btn_disabled}
                hitArea={BUTTON_HIT_AREA}
                visible={props.showAutoSpinButton}
                action={() => uiMainScreenEmitter.emit('PRESSED_AUTOPLAY_OPTIONS')}
                responsive={{
                    box: {x: '50%', y: '50%'},
                    translate: {x: '465px'}
                }}
            />
            <$Button
                name='auto_on_btn'
                disabled={uiElementsStore.auto_btn_disabled}
                hitArea={BUTTON_HIT_AREA}
                visible={props.showAutoSpinOnButton}
                action={() => uiMainScreenEmitter.emit('PRESSED_AUTOPLAY_OPTIONS')}
                responsive={{
                    box: {x: '50%', y: '50%'},
                    translate: {x: '465px'}
                }}
            />
        </$Container>
    </$Container>;
};